/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.getUploadLimits'

export { $nsid }

/** Get video upload limits for the authenticated user. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    canUpload: l.boolean(),
    remainingDailyVideos: l.optional(l.integer()),
    remainingDailyBytes: l.optional(l.integer()),
    message: l.optional(l.string()),
    error: l.optional(l.string()),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
